import { useRequiredContext } from "@redotech/react-util/context";
import { useTranslation } from "@redotech/redo-i18n";
import { MerchantRoutesContext } from "@redotech/redo-merchant-app-common/merchant-routes";
import { RedoSecondaryNavItem } from "@redotech/redo-web/arbiter-components/navigation/secondary/redo-secondary-nav-item";
import { TeamContext } from "@redotech/redo-web/context/team-context";
import { memo } from "react";
import { useMatch } from "react-router-dom";
import {
  LOYALTY_ICON,
  LOYALTY_ICON_FILLED,
} from "../../../../redo-suite/marketing-cloud";

export const LoyaltyItems = memo(function LoyaltyItems() {
  const { t } = useTranslation();
  const team = useRequiredContext(TeamContext);
  const routes = useRequiredContext(MerchantRoutesContext);

  const loyaltyEnabled = team?.settings.marketing?.loyalty?.enabled;

  const loyaltyBaseUrl = routes.marketingBaseUrl + "/loyalty";
  const anyChildSelected = useMatch(`${loyaltyBaseUrl}/*`);

  if (!loyaltyEnabled) {
    return null;
  }

  return (
    <RedoSecondaryNavItem
      action={{ type: "link", href: routes.getLoyaltySubRoute("program") }}
      anyChildSelected={!!anyChildSelected}
      FilledIcon={LOYALTY_ICON_FILLED}
      friendlyName={t("Loyalty", {
        context: "merchant marketing navigation label",
      })}
      id="loyalty"
      UnfilledIcon={LOYALTY_ICON}
    >
      <LoyaltyMembersItem />
      <LoyaltyOnSiteItem />
      <LoyaltyPointsProgramItem />
      <LoyaltyPromotionsItem />
    </RedoSecondaryNavItem>
  );
});

const LoyaltyMembersItem = memo(function LoyaltyMembersItem() {
  const { t } = useTranslation();
  const routes = useRequiredContext(MerchantRoutesContext);

  return (
    <RedoSecondaryNavItem
      action={{ type: "link", href: routes.getLoyaltySubRoute("members") }}
      friendlyName={t("Members", {
        context: "merchant marketing navigation label",
      })}
      id="loyalty-members"
    />
  );
});

const LoyaltyOnSiteItem = memo(function LoyaltyOnSiteItem() {
  const { t } = useTranslation();
  const routes = useRequiredContext(MerchantRoutesContext);

  return (
    <RedoSecondaryNavItem
      action={{ type: "link", href: routes.getLoyaltySubRoute("on-site") }}
      friendlyName={t("On-site", {
        context:
          "loyalty navigation label for rewards shown on the merchant storefront",
      })}
      id="loyalty-on-site"
    />
  );
});

const LoyaltyPointsProgramItem = memo(function LoyaltyPointsProgramItem() {
  const { t } = useTranslation();
  const routes = useRequiredContext(MerchantRoutesContext);

  return (
    <RedoSecondaryNavItem
      action={{ type: "link", href: routes.getLoyaltySubRoute("program") }}
      friendlyName={t("Points program", {
        context: "merchant marketing navigation label",
      })}
      id="loyalty-program"
    />
  );
});

const LoyaltyPromotionsItem = memo(function LoyaltyPromotionsItem() {
  const { t } = useTranslation();
  const routes = useRequiredContext(MerchantRoutesContext);

  return (
    <RedoSecondaryNavItem
      action={{ type: "link", href: routes.getLoyaltySubRoute("promotions") }}
      friendlyName={t("Promotions", {
        context: "merchant marketing navigation label",
      })}
      id="loyalty-promotions"
    />
  );
});
